import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from './loading.component';
import { LoadingPaybyrdComponent } from './loadingPaybyrd.component'
import { LoadingCircleComponent } from '../loading-circle/loading-circle.component';
import { LoadingShadowComponent } from '../loading-shadow/loading-shadow.component';

@NgModule({
	imports: [
		CommonModule,
	],
	declarations: [
		LoadingComponent,
		LoadingPaybyrdComponent,
		LoadingCircleComponent,
		LoadingShadowComponent
	],
	exports: [
		LoadingComponent,
		LoadingPaybyrdComponent,
		LoadingCircleComponent,
		LoadingShadowComponent
	]
})
export class LoadingModule { }
